import Fetch from '../fetch';

const END_POINTS = {
	news: 'news',
	items: 'items',
	filters: 'filters',
	public: 'public',
	search: 'search',
	courses: 'courses',
	sections: 'sections',
	messages: 'messages',
	prefix: 'landingPage',
	unsubscribe: 'unsubscribe',
	schedules: 'schedules',
	subscribers: 'subscribers',
	instructors: 'instructors',
	scheduleRequests: 'scheduleRequests'
};


class LandingPageApiHandler {
	async subscribers(data) {
		return Fetch.post(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.news}/${END_POINTS.subscribers}`, data);
	}

	async unsubscribe(data) {
		return Fetch.post(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.news}/${END_POINTS.unsubscribe}`, data);
	}

	async getLandingPageData() {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.sections}`);
	}

	async sendMessage(data) {
		return Fetch.post(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.messages}`, data);
	}

	async scheduleRequests({ data, courseId }) {
		return Fetch.post(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${courseId}/${END_POINTS.scheduleRequests}`, data);
	}

	async getSections(id) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.sections}/${id}`);
	}

	async getCourses(languageId) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${languageId}`);
	}

	async getInstructors(filter) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.instructors}`, filter);
	}

	async getCoursesFilters() {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${END_POINTS.filters}`);
	}

	async searchCourses(filter) {
		return Fetch.post(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${END_POINTS.search}`, filter);
	}

	async getInstructor(instructorId) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.instructors}/${instructorId}`);
	}

	async getCourseSchedules(id) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${END_POINTS.schedules}/${id}/${END_POINTS.items}`);
	}

	async getPublicCourseDetail(courseId) {
		return Fetch.get(`${END_POINTS.prefix}/${END_POINTS.public}/${END_POINTS.courses}/${courseId}`);
	}
}

const landingPageApiHandler = new LandingPageApiHandler();
export default landingPageApiHandler;
